import React from "react"
import DefinedRange from "./DefinedRange"
import { DefinedRangeType, RangeCalendar } from "../MultiRangeCalendar.domain"
import withVisibility from "components/Shared/Hocs/withVisibility/withVisibility"

interface CalendarPresetsProps {
	definedRanges: DefinedRangeType[]
	ranges: RangeCalendar[]
	onChange: (rangeCalendar: RangeCalendar[], pressedSelected: string) => void
}

const CalendarPresets: React.FC<CalendarPresetsProps> = (props) => {
	const { definedRanges, onChange, ranges } = props

	return (
		<div className="presets-container">
			<ul>
				{definedRanges.map((range: DefinedRangeType) => {
					return (
						<li key={range.id}>
							<DefinedRange
								onChange={(rangeCalendar) => {
									onChange(rangeCalendar, range.id)
								}}
								definedRangeFunction={() => range.fn()}
								label={range.label}
								isSelected={range.isSelected}
								ranges={ranges}
							></DefinedRange>
						</li>
					)
				})}
			</ul>
		</div>
	)
}

export default withVisibility(CalendarPresets)
